var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","outlined":"","small":""},on:{"click":_vm.generate}},[_vm._v(" Export CSV "),_c('i',{staticClass:"mdi mdi-export-variant",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }